import { defineMessages } from 'react-intl';

export default defineMessages({
    noModules: {
        id: 'components.moduleCards.noModules',
        defaultMessage: 'No modules',
    },
});
